export default __webpack_public_path__ + "static/media/googlePlayIcon.1bc718f7.png";